import React, { useEffect } from "react";
import { useState } from "react";
import axios from "axios";

const initialLoader = (key) => {
  try {
    switch (key) {
      case "userDetails":
        return JSON.parse(localStorage.getItem("userDetails"));
      default:
        return null;
    }
  } catch (error) {
    return null;
  }
};

const useLoginDeatils = (key) => {
  const [customState, setCustomState] = useState(initialLoader(key));

  useEffect(() => {
    const fetchRecord = async () => {
      try {
        switch (key) {
          case "userDetails":
            if (!localStorage.getItem(key)) {
              const response = await axios.get("/api/user/details");
              localStorage.setItem(
                "userDetails",
                JSON.stringify(response.data)
              );
              setCustomState(JSON.parse(localStorage.getItem("userDetails")));
            }
            break;
          default:
            console.log("Worng key passed");
            setCustomState({});
        }
      } catch (error) {
        setCustomState({});
      }
    };

    fetchRecord();
  }, [key]);
  const setStorage = (action, item = null) => {
    switch (action.type) {
      case "add":
        localStorage.setItem(key, item);
        setCustomState(item);
        break;
      case "remove":
        localStorage.removeItem(key);
        setCustomState({});
        break;
      default:
    }
  };
  return [customState, setStorage];
};
export default useLoginDeatils;
